// Shared publishing status options used by Live Control and Matches List filters
export const PUBLISHING_STATUS_OPTIONS = [
    { value: 'PUBLISHED', label: 'Published' },
    { value: 'SCHEDULED', label: 'Scheduled' },
    { value: 'DRAFT', label: 'Draft' },
    { value: 'CANCELLED', label: 'Cancelled' },
    { value: 'WITHDRAWN', label: 'Withdrawn' },
    { value: 'UNPUBLISHED', label: 'Unpublished' },
] as const

export type PublishingStatus = typeof PUBLISHING_STATUS_OPTIONS[number]['value']
